(function () {
    'use strict';

    angular
        .module('core.directives')
        .directive('unitVideos', UnitVideos);

    /** @ngInject */
    function UnitVideos($rootScope, UnitService, HelperService, NotifyService, sweetAlert, PATHS) {
        function UnitVideosDirectiveController($scope) {
            const vm = this;

            let removeWatchShow = $scope.$watch('vm.show', (newValue) => {
                if (newValue)
                    init();
            });

            $scope.$on('$destroy', () => {
                removeWatchShow();
            });

            vm.flowFileAdded = ($file, $flow) => {
                let extension = ($file.getExtension() || '').toLowerCase();
                let accepted = ['mp4', 'webm'];

                if (!accepted.includes(extension)) {
                    NotifyService.error('Apenas vídeos MP4 ou WEBM são permitidos.');
                    HelperService.setErrorMessageForm('.video-upload', 'Formato inválido.', true);
                    return false;
                }

                angular.extend($flow.opts, vm.flowOptionsVideo);
                HelperService.removeErrorMessageForm('.video-upload');

                return true;
            };

            vm.flowFileSubmitted = $flow => {
                $flow.upload();
            };

            vm.flowFileFinished = ($file, $message) => {
                let message = angular.fromJson($message);
                vm.form.UrlVideo = message.FileSaveName;
            };

            vm.flowFileError = $flow => {
                $flow.files = [];
                NotifyService.error('Não foi possível enviar o vídeo.');
            };

            vm.setEdit = video => {
                vm.form = {
                    Id: video.Id,
                    UnitId: vm.unitData.Id,
                    UrlVideo: video.UrlVideo,
                    UrlVideoAzure: video.UrlVideoAzure,
                    Description: video.Description,
                    Active: video.Active
                };
            };

            vm.cancelEdit = () => {
                resetForm();
            };

            vm.save = () => {
                if (!vm.form.UrlVideo || !vm.form.UrlVideo.trim()) {
                    NotifyService.error('Faça o upload de um vídeo antes de salvar.');
                    return;
                }

                let payload = {
                    Id: vm.form.Id,
                    UnitId: vm.unitData.Id,
                    UrlVideo: vm.form.UrlVideo,
                    Description: vm.form.Description,
                    Active: vm.form.Active
                };

                HelperService.startLoading('.loading-holder');

                let request = payload.Id
                    ? UnitService.putVideo(payload)
                    : UnitService.postVideo(payload);

                request.then(() => {
                    resetForm();
                    loadVideos();
                    HelperService.stopLoading('.loading-holder');
                    HelperService.successCallback(payload.Id ? 'update' : 'create');
                }, error => {
                    HelperService.stopLoading('.loading-holder');
                    HelperService.errorCallback(error);
                });
            };

            vm.delete = video => {
                sweetAlert.swal({
                    title: 'Você tem certeza?',
                    text: 'Não é possível desfazer essa ação!',
                    type: 'warning',
                    confirmButtonText: 'Sim, tenho certeza',
                    showCancelButton: true,
                    cancelButtonText: 'Não, cancelar',
                    allowOutsideClick: false,
                    allowEscapeKey: false
                }).then(response => {
                    if (!response.value)
                        return;

                    HelperService.startLoading('.loading-holder');

                    UnitService
                        .deleteVideo(video.Id)
                        .then(() => {
                            vm.videos = vm.videos.filter(x => x.Id !== video.Id);
                            HelperService.stopLoading('.loading-holder');
                            HelperService.successCallback('delete');
                        }, error => {
                            HelperService.stopLoading('.loading-holder');
                            HelperService.errorCallback(error);
                        });
                });
            };

            vm.getVideoDisplay = video => {
                if (!video)
                    return '';

                if (video.UrlVideoAzure)
                    return video.UrlVideoAzure;

                if (!video.UrlVideo)
                    return '';

                return HelperService.imageHandlerPath('unit-video', vm.unitData.Id, video.UrlVideo);
            };

            vm.getVideoDisplayFromForm = () => {
                if (!vm.form)
                    return '';

                if (vm.form.UrlVideoAzure)
                    return vm.form.UrlVideoAzure;

                if (!vm.form.UrlVideo)
                    return '';

                return HelperService.imageHandlerPath('unit-video', vm.unitData.Id, vm.form.UrlVideo);
            };

            function loadVideos() {
                if (!vm.unitData || !vm.unitData.Id)
                    return;

                UnitService
                    .getVideos(vm.unitData.Id)
                    .then(success => {
                        vm.videos = success || [];
                    }, error => {
                        HelperService.errorCallback(error);
                    });
            }

            function resetForm() {
                vm.form = {
                    Id: 0,
                    UnitId: vm.unitData.Id,
                    UrlVideo: '',
                    UrlVideoAzure: '',
                    Description: '',
                    Active: true
                };
            }

            function initVars() {
                vm.canUserCreate = $rootScope.canUserCreate;
                vm.canUserEdit = $rootScope.canUserEdit;
                vm.isReadOnly = vm.readOnly || !(vm.canUserCreate || vm.canUserEdit);

                vm.videos = [];
                vm.flowOptionsVideo = {
                    query: () => {
                        return {
                            Path: `unit-video/${vm.unitData.Id}`,
                            CreateThumb: false,
                            CreateThumbAdmin: false,
                            MaxSize: 104857600
                        };
                    }
                };

                angular.extend(vm.flowOptionsVideo, HelperService.getFlowOptionsDefaultsVideoUpload());
            }

            function init() {
                initVars();
                resetForm();
                loadVideos();
            }
        }

        return {
            bindToController: true,
            controller: UnitVideosDirectiveController,
            controllerAs: 'vm',
            restrict: 'AE',
            templateUrl: `${PATHS.PHYSICAL}/directives/unit-videos/unit-videos.html`,
            scope: {
                unitData: '=',
                show: '=',
                readOnly: '=?'
            }
        };
    }
}());
